<!-- youtube-mobile-02 preview — YouTube watch page, square image ad under the player -->
<app-mobile-frame>
  <!-- START: Player -->
  <img class="yt-m-player" src="/assets/images/youtube-placeholder-video.png" alt="" frameTop />
  <!-- END: Player -->

  <!-- START: Feed -->
  <div class="yt-m-feed">
    <!-- START: Real ad -->
    <div class="yt-m-card">
      <div class="yt-m-creative">
        <img *ngIf="creativeImage" class="yt-m-creative-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="yt-m-creative-image creative-missing">{{ missingDimensionLabel }}</div>
        <i class="bi bi-info-circle-fill yt-m-info-badge"></i>
      </div>

      <div
        class="yt-m-cta d-flex flex-row align-items-center justify-content-between"
      >
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="yt-m-cta-text"
          >{{ data.ctaText || "Your call to action" }}
        </a>
        <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="yt-m-cta-text"
          ><i class="bi bi-box-arrow-up-right"></i
        ></a>
      </div>

      <div class="yt-m-info d-flex flex-row gap-2">
        <img
          class="yt-m-avatar"
          src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
          alt=""
        />
        <div class="yt-m-info-text">
          <h4 class="yt-m-title">
            {{ data.headlines[0] || "Your headline appears here" }}
          </h4>
          <div class="yt-m-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>
          <div class="yt-m-meta">
            <strong>Sponsored</strong> &middot; Valamar
          </div>
        </div>
        <i class="bi bi-three-dots-vertical yt-m-more"></i>
      </div>
    </div>
    <!-- END: Real ad -->
  </div>
  <!-- END: Feed -->
</app-mobile-frame>
